import { GraphQLErrors } from '@apollo/client/errors';
import { GraphQLExtensions } from 'src/services/graphql/types';
import { isUndefined } from 'src/utils/typeguards/isUndefined';

export const UNAUTHORIZED_EXTENSION_INDICATORS = {
    ERROR_TYPE: 'PERMISSION_DENIED',
    CODE: 'FORBIDDEN',
    TYPE: 'InsufficientPermissions',
};

export const isUnauthorizedError = (graphQLErrors: undefined | GraphQLErrors): boolean =>
    !isUndefined(graphQLErrors) &&
    !!graphQLErrors.length &&
    graphQLErrors.some(error => {
        const { extensions = {} } = error ?? {};
        const { code, errorType, response } = extensions as GraphQLExtensions;

        const isUnauthorizedCode = code === UNAUTHORIZED_EXTENSION_INDICATORS.CODE;
        const isUnauthorizedErrorType = errorType === UNAUTHORIZED_EXTENSION_INDICATORS.ERROR_TYPE;
        const isUnauthorizedResponse = response?.body?.type === UNAUTHORIZED_EXTENSION_INDICATORS.TYPE;
        const isUnauthorizedStatus = response?.status === 403 || response?.status === 401;
        return isUnauthorizedCode || isUnauthorizedErrorType || isUnauthorizedResponse || isUnauthorizedStatus;
    });
